import React from 'react';

const VideoMockup = () => {
  return (
    <div className="mac-window">
      {/* Window title bar */}
      <div className="mac-window-bar">
        <span className="mac-dot bg-[#FF5F57]"></span>
        <span className="mac-dot bg-[#FEBC2E]"></span>
        <span className="mac-dot bg-[#28C840]"></span>
        <span className="flex-1 text-center font-mono text-xs text-mist pr-12">
          Ghost Text — capture.mov
        </span>
      </div>
      <video
        className="w-full h-auto block"
        autoPlay
        loop
        muted
        playsInline
        poster="/GhostText.png"
      >
        <source src="/gifpurple.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoMockup;
